export async function fetchArticleById(id: string | number) {
  const res = await http.get<Article.Detail>('/v1/article/get', {
    id,
    html: 1
  })
  return res.data
}
